/** How two authored names are compared for "already taken" — trimmed, case-insensitive. */
export const normalizedName = (name: string): string => name.trim().toLowerCase();
